import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { SimpleFlexbox } from '../../../flexbox/flexbox';
import styles from './no_results_overlay.css';

/**
 * Displays a full page overlay when their is no quote results to display
 * @type {Component} NoResultsOverlay returns a NoResultsOverlay Component
 */
class NoResultsOverlay extends Component {

    /**
     * Renders the layout of the no_results_overlay including Text and the Cross Sell Component.
     * @returns {Node} - renders the noResultsOverlay
     */
    render = () => {
        const { children } = this.props;
        return (
            <SimpleFlexbox className={styles.main} display="flex" column itemsCenter="xs" xs={12} md={9} lg={9} xl={10} xxl={12}>
                <SimpleFlexbox className={styles.logo_container} row wrap contentCenter="xs">
                    {children}
                </SimpleFlexbox>
            </SimpleFlexbox>
        );
    };

}

NoResultsOverlay.propTypes = {
    children: PropTypes.node
};

export { NoResultsOverlay };
